import { render, staticRenderFns } from "./extrapre.vue?vue&type=template&id=7ecfad3a&"
import script from "./extrapre.vue?vue&type=script&lang=js&"
export * from "./extrapre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports